import React from "react";

/**
 * DiamondDivider — signature gold-diamond rule (DESIGN.md §5).
 * A gold square rotated 45° flanked by gradient hairlines fading to transparent.
 * Use in place of a plain <hr>. Pass `vertical` for a column divider between
 * two panes (fades at top/bottom, diamond centered).
 */
export default function DiamondDivider({ className = "", vertical = false }) {
  return (
    <div
      className={`diamond-divider${vertical ? " diamond-divider--vertical" : ""} ${className}`}
      aria-hidden="true"
    >
      <span className="diamond-divider__line" />
      <span className="diamond-divider__gem" />
      <span className="diamond-divider__line" />
    </div>
  );
}
